import React from 'react';
import { useTranslation } from 'react-i18next';

import PagetitleAndDescription from 'components/pageTitleAndDescription';
import Tabs from 'components/tabs';

import SearchFilterTab from './searchFiltersTab';
import ColumnsTab from './columnsTab';

const SearchVehiclePage = () => {
  const { t } = useTranslation();

  const tabs = [
    {
      title: t('pages.searchVehiclePage.searchFiltersTab.title'),
      path: t('routes.searchVehiclePageSearchFiltersTab'),
      component: <SearchFilterTab />,
    },
    {
      title: t('pages.searchVehiclePage.resultsTab.title'),
      path: t('routes.searchVehiclePageColumnsTab'),
      component: <ColumnsTab />,
    },
  ];

  return (
    <>
      <PagetitleAndDescription
        title={t('pages.searchVehiclePage.title')}
      />
      <Tabs tabs={tabs} />
    </>
  );
};

export default SearchVehiclePage;
